<template>
  <div class="pay-succ">
    <img src="@/assets/images_member/icon-ding2 (8).png" class="img" alt="">
    <div class="pay-txt1">赠送成功</div>
    <div class="pay-txt2">
      <div class="label">赠送账号：</div>
      <div class="val">{{ mobile }}</div>
    </div>
    <div class="pay-txt2">
      <div class="label">名额剩余：</div>
      <div class="val">{{ userInfo.give_svip }}个</div>
    </div>
    <div class="return-btn" @click="handleJump">返回</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menberOrder: {},
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    },
    mobile () {
      return this.$route.query.mobile
    }
  },
  created () {
    this.menberOrder = JSON.parse(sessionStorage.getItem('menberOrder'))
  },
  methods: {
    handleJump() {
      this.$router.push({
        path: '/giftMenber'
      })
    }
  },
}
</script>

<style lang="less" scoped>
.pay-succ {
  background-color: #1E2020;
  padding: 30px 14px;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;

  .img {
    width: 146px;
    display: block;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
  }

  .pay-txt1 {
    font-size: 20px;
    color: #F0E1C0;
    font-weight: bold;
    line-height: 20px;
    margin-top: 24px;
    text-align: center;
    margin-bottom: 18px;
  }

  .pay-txt2 {
    text-align: left;
    width: 150px;
    margin-left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 12px;
    display: flex;
    line-height: 24px;
  }

  .return-btn {
    width: 240px;
    height: 54px;
    background-color: #F0E1C0;
    border-radius: 100px;
    text-align: center;
    line-height: 54px;
    color: #504632;
    font-weight: 600;
    font-size: 18px;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/paySuccess2.vue